import { n as normalizeComponent } from './normalize-component.js';

//
//
//
//
//
//
//
//
//
var script = {
  mounted: function mounted() {
    var _this = this;

    this.$xp.screen.setOrientation('landscape');
    this.statusPositionTimeout = setInterval(function () {
      _this.changePosition();
    }, 3000);
    window.localStorage.removeItem('nfcLangCode');
    window.localStorage.removeItem('nfcSelectedBranchIds');
    this.sleepOrDont();
  },
  data: function data() {
    return {
      statusPositionTimeout: null,
      sleepTimeout: null
    };
  },
  computed: {
    batteryLevel: function batteryLevel() {
      return this.$xp.battery.level;
    },
    batteryColor: function batteryColor() {
      var r = this.batteryLevel < 50 ? 255 : Math.floor(255 - (this.batteryLevel * 2 - 100) * 255 / 100);
      var g = this.batteryLevel > 50 ? 255 : Math.floor(this.batteryLevel * 2 * 255 / 100);
      return 'rgb(' + r + ',' + g + ',0)';
    }
  },
  methods: {
    changePosition: function changePosition() {
      var leftRange = window.innerWidth - this.$refs.batteryDiv.offsetWidth;
      var left = Math.random() * leftRange * 0.70 + leftRange * 0.3;
      var topRange = window.innerHeight - this.$refs.batteryDiv.offsetHeight;
      var top = Math.random() * (topRange * 0.70);
      this.$refs.batteryDiv.style.left = left + 'px';
      this.$refs.batteryDiv.style.top = top + 'px';
    },
    onDockClick: function onDockClick() {
      this.$router.replace('/');
    },
    sleepOrDont: function sleepOrDont() {
      if (this.batteryLevel > this.$xp.settings.mergedSettings.battery.dockSleepLevel) {
        this.$xp.screen.setSleepTimeOut(this.$xp.settings.mergedSettings.screen.standbySeconds * 1000);
      } else {
        this.$xp.screen.preventSleep();
      }
    }
  },
  watch: {
    batteryLevel: function batteryLevel() {
      this.sleepOrDont();
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.$xp.screen.preventSleep();
    clearInterval(this.statusPositionTimeout);
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "c-dock",
      on: {
        click: function($event) {
          return _vm.onDockClick()
        }
      }
    },
    [
      _c(
        "div",
        {
          ref: "batteryDiv",
          staticClass: "c-dock__battery",
          style: "color:" + this.batteryColor
        },
        [
          _c("h1", [_vm._v(_vm._s(_vm.batteryLevel) + "%")]),
          _vm._v(" "),
          _c("div", [_vm._v("click to start")])
        ]
      )
    ]
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
//# sourceMappingURL=Dock.js.map
